import React from 'react';
import PopOversContainer from '../../Componant/UiKits/Popover';

const PopOvers = () => {
  return (
    <div className='page-body'>
      <PopOversContainer />
    </div>
  );
};

export default PopOvers;
